const $ = jQuery.noConflict();

export const scrollDown = () => {
    $('#scroll-down-button').on('click', e => {
        e.preventDefault();
        const windowHeight = $(window).height()
        const windowOffset = $(window).scrollTop();
        $('html, body').animate({ scrollTop: windowHeight + windowOffset }, 500);
    })
};
